import React from 'react'

const en_us = {
    values: {
        'Click to add note': 'Click to add note',
        'ADD NOTE': 'ADD NOTE',
        NOTE: 'NOTE',
        Note: 'Note',
        NOTES: 'NOTES',
        BACK: 'BACK',
        'BACK TO NOTES LIST': 'BACK TO NOTES LIST',
        'added a note': 'added a note',
        From: 'From',
        To: 'To',
        optional: 'optional',
        'New note': 'New note',
        'Note saved successfully': 'Note saved successfully',
        'Annotated range': 'Annotated range',
        'Annotated time': 'Annotated time',
        'Timeline disabled on this dashboard': 'Timeline disabled on this dashboard',
        'Toggle timeline visibility': 'Toggle timeline visibility',
        'Toggle Timeline on': 'Show timeline',
        'Toggle Timeline off': 'Hide timeline',
        'The end date must be after the start date': 'The end date must be after the start date',
        'Invalid end date': 'Invalid end date',
        'The final value must be greater than the initial value':
            'The final value must be greater than the initial value',
        'Invalid from date': 'Invalid from date',
        'Timeline options': 'Timeline options',
        'Enable timeline': 'Enable timeline',
        'Timeline format': 'Timeline format',
        Temporal: 'Temporal',
        Numeric: 'Numeric',
        'Are you sure you want to delete this note': 'Are you sure you want to delete this note?',
        by: 'by',
        on: 'on',
        'Add Note': 'Add Note',
        CREATE: 'CREATE',
        'This is a required field.': 'This is a required field.',
        'Note text': 'Note text',
        'Nothing found here.': 'Nothing found here.',
        'Note successfully deleted': 'Note successfully deleted',
        'CREATE NOTE': 'CREATE NOTE',
        'EDIT NOTE': 'EDIT NOTE',
        marker_widget_action_msg: (
            <React.Fragment>
                <div className="bulb-icon">
                    <i className="far fa-lightbulb-on" />
                </div>
                <div className="msg">
                    To create a marker, drag your mouse through the highlighted chart and click on the selected point.
                    You can cancel at any time by typing ESC on your keyboard.
                    <br />
                    <b>
                        You can also use the Alt + Click shortcut to place marker in the current chart or Shift + Click
                        to place a marker in all charts.
                    </b>
                    {/*<b>You can also enable the marker with the Alt + Click shortcut. Or use the Shift + Click</b>*/}
                </div>
            </React.Fragment>
        ),
        marker_widget_action_msg_2: (
            <React.Fragment>
                <div className="bulb-icon">
                    <i className="far fa-lightbulb-on" />
                </div>
                <div className="msg">
                    To create a marker, drag your mouse through the highlighted chart and click on the selected point.
                </div>
            </React.Fragment>
        ),
        marker_widget_action_msg_3:
            'Are you sure you want to delete this marker? The annotation relating to that marker will also be deleted',
        'No note text': 'No text',
        extend_history_help_block: ({ pipesVersion }: { pipesVersion: string }) => {
            return <>"Extend history" is a pipes period. Learn more about it at <a target="_blank" href={`https://pipes.intelie.com/docs/${pipesVersion}/#timespan-period`}>pipes documentation</a>. </>
        }
    }
}

module.exports = en_us
